import "./AboutRiverBend.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import IndustryExpertise from "./sections/IndustryExpertise";
import TheGladiolusStandard from "./sections/TheGladiolusStandard";
import Footer from "@/reusable_sections/Footer";
export default function AboutRiverBendPage() {
  return <div>
      <Header />
      <OurStory />
      <IndustryExpertise />
      <TheGladiolusStandard />
      <Footer />
    </div>;
}